import React from 'react'
import Fragment from '../common/fragment'

function FragmentAA(props) {
  return (
    <Fragment pos="a" {...props}>
      <p>
      Entrar o salir de un valle y sentir una inquietud intensa o apaciguada. Mirar las colinas o las montañas que lo rodean y atisbar, con los ojos semicerrados, la luz que emerge de la tierra o se esparce en el cielo. Vadear los valles como ovejas.
      Encontrar caminos entre los árboles y silencios en los susurros. El valle se
      desprende de la tierra y como una nube flota sobre sí mismo. Entonces, sentimos
      inquietud: ¿pueden las cosas ser un cuerpo y también una sombra?, ¿podemos
      contemplar sus deslices y también atestiguar su quietud? La especie humana es
      heredera de todas las especies, dice Deligny, incluso “de las nubes que emanan”.
      “Es un revoltijo totalmente disparatado”. ¿Quiénes heredarán los valles?, ¿qué
      quedará de ellos? Las ovejas pastan entre nubes y otras emanaciones que se
      dispersan. Tal vez ellas mismas son nubes que caminan y balan. Eso es lo
      inquietante, que todo pueda ser algo distinto. Incluso donde no haya nada,
      absolutamente nada, oiremos balar a las ovejas, de vez en cuando. El silencio también será un balido.
      </p>
    </Fragment>
  )
}


export default FragmentAA
